import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-full-screen-proofcard',
  templateUrl: './full-screen-proofcard.component.html',
  styleUrls: ['./full-screen-proofcard.component.css']
})
export class FullScreenProofcardComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  ngOnInit() {
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
